// extracted by mini-css-extract-plugin
module.exports = {"root":"DurationItem_root__vSELN"};